var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutoTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 12.5H25L13.75 28.75V17.5H5L16.25 1.25V12.5Z",
    fill: "#1D1E24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoTheme);
export default __webpack_public_path__ + "static/media/auto-theme.dadf68572eb5dd8bff16b6a84bbff2b6.svg";
export { ForwardRef as ReactComponent };